import React from "react";
import ReactApexChart from "react-apexcharts";

const CallsByMemberWidget = ({ callsByMember = [] }) => {
  if (!callsByMember.length) {
    return <p className="callOutcomesEmpty">No calls by member data</p>;
  }

  const memberNames = callsByMember.map(m => m.name || "Unknown");
  const connectedCounts = callsByMember.map(m => m["Connected"] || 0);
  const dynamicMax = Math.max(...connectedCounts, 1);

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      animations: { enabled: false },
      selection: { enabled: false },
      zoom: { enabled: false }
    },
    plotOptions: {
      bar: {
        borderRadius: 3,
        columnWidth: "55%",
        distributed: true
      }
    },
    colors: ["#16a34a"],
    dataLabels: { enabled: false },
    legend: { show: false },
    xaxis: {
      categories: memberNames,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      min: 0,
      max: dynamicMax,
      tickAmount: 4,
      labels: {
        formatter: val => Math.round(val),
        style: { fontSize: "10px", colors: "#999" }
      }
    },
    grid: {
      borderColor: "#e8ebee",
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } }
    },
    tooltip: {
      x: { show: true },
      y: {
        title: { formatter: () => "Connected:" },
        formatter: val => `${val}`
      }
    }
  };

  const series = [{ name: "Connected", data: connectedCounts }];

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={140}
      width="100%"
    />
  );
};

export default CallsByMemberWidget;
